import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwoColumnsPanelComponent } from './two-columns-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [TwoColumnsPanelComponent],
  exports: [TwoColumnsPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class TwoColumnsPanelModule { }
